import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
let nextId = 0;

/**
 * Manages the queue of realtime notification toasts.
 * Each toast auto-dismisses after the configured flarum-realtime.notification-toast-dismiss-after seconds.
 */
export default class NotificationToastState {
  constructor() {
    _defineProperty(this, "toasts", []);
  }
  all() {
    return this.toasts;
  }
  push(notification) {
    var _app$data$settings, _app$data, _settings$flarumReal;
    const settings = (_app$data$settings = (_app$data = app.data) == null ? void 0 : _app$data.settings) != null ? _app$data$settings : {};
    const dismissAfterS = (_settings$flarumReal = settings['flarum-realtime.notification-toast-dismiss-after']) != null ? _settings$flarumReal : 10;
    if (dismissAfterS === 0) return;
    const id = nextId++;
    this.toasts.push({
      id,
      notification
    });
    m.redraw();
    setTimeout(() => this.dismiss(id), dismissAfterS * 1000);
  }
  dismiss(id) {
    const index = this.toasts.findIndex(t => t.id === id);
    if (index !== -1) {
      this.toasts.splice(index, 1);
      m.redraw();
    }
  }
}
flarum.reg.add('flarum-realtime', 'forum/states/NotificationToastState', NotificationToastState);